import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";
import {
  url_276,
  url_277,
  url_278,
  url_279,
  url_280,
  url_281,
  url_282,
  url_283,
  url_284,
  url_285,
  url_286,
} from "../../custom_utilities/api_services";

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.append(key, value);
    }
  });
  const q = search.toString();
  return q ? `?${q}` : "";
};

const adaptiveQBankApi = {
  /** POST — body e.g. { subject, topic_id } */
  postAdaptiveHomepage: async (body) => {
    const res = await axioInstance.post(url_276, body);
    return res.data;
  },

  /** GET — query e.g. { paper_type, adaptive_question_id } */
  getAllQuestionList: async (params) => {
    const res = await axioInstance.get(`${url_277}${buildQuery(params)}`);
    return res.data;
  },

  /** POST */
  postAdaptiveSubjectList: async (body = {}) => {
    const res = await axioInstance.post(`${url_278}${buildQuery(body)}`, {});
    return res.data;
  },

  /** POST — adaptive topic-wise */
  postAdaptiveSubjectTopicList: async (body = {}) => {
    const res = await axioInstance.post(`${url_279}${buildQuery(body)}`, {});
    return res.data;
  },

  /** POST — sub-topic list */
  postAdaptiveSubtopicsList: async (body = {}) => {
    const res = await axioInstance.post(url_280, body);
    return res.data;
  },

  /** POST */
  postAdaptiveLearningSummary: async (body = {}) => {
    const res = await axioInstance.post(url_281, body);
    return res.data;
  },

  /** GET — query e.g. { paper_id, paper_type } */
  getPractiseSolution: async (params) => {
    const res = await axioInstance.get(`${url_282}${buildQuery(params)}`);
    return res.data;
  },

  /** GET — query e.g. { adaptive_question_id, qid, paper_type } */
  getExamSingleQuestionAdaptive: async (params) => {
    const res = await axioInstance.get(`${url_283}${buildQuery(params)}`);
    return res.data;
  },

  /** POST */
  postExamSingleSave: async (body = {}) => {
    const res = await axioInstance.post(url_284, body);
    return res.data;
  },

  /** POST */
  postExamSubmit: async (body = {}) => {
    const res = await axioInstance.post(url_285, body);
    return res.data;
  },

  /** POST — UserAdaptiveAnalysis summary */
  postUserAdaptiveAnalysis: async (body = {}) => {
    const res = await axioInstance.post(url_286, body);
    return res.data;
  },
};

export default adaptiveQBankApi;
